import { InputBase, Tooltip } from "@mui/material";

type Props = {
  disabled: boolean;
  handleChangeQtyAsked: (
    event: any,
    rowProduct: any,
    index: number,
    quantity?: number
  ) => void;
  index: number;
  product: {
    qty: number;
    qtyAsked: number;
    receptionReferenceId: number;
  };
};

function QuantityInput({
  disabled,
  handleChangeQtyAsked,
  index,
  product,
}: Props) {
  const isAReferencedProduct = !!product.receptionReferenceId;
  return (
    <Tooltip
      title={
        isAReferencedProduct
          ? `Pour changer cette quantité, veuillez retirer la référence du tableau de suivi puis la modifier depuis l'onglet "Besoin Matériel".`
          : ""
      }
    >
      <InputBase
        type="number"
        inputProps={{
          min: 1,
          step: "1",
          style: {
            textAlign: "center",
            background: "#fff",
            height: 25,
            border: "1px solid #eee",
            borderRadius: 5,
            fontSize: 16,
          },
        }}
        onChange={(e) => handleChangeQtyAsked(e, product, index)}
        value={product.qtyAsked}
        disabled={disabled || isAReferencedProduct}
      />
    </Tooltip>
  );
}

export default QuantityInput;
